import type {
    AppMarketingAppLinks,
    AppMarketingPlatform
} from '@/features/app-marketing/logic/app-marketing-app-links';

export type ClientPlatformDetails = {
    platform?: AppMarketingPlatform;
    appLink?: string;
    isMobile: boolean;
};

const SUPPORTED_PLATFORMS: AppMarketingPlatform[] = ['ios', 'android', 'mac', 'windows'];

export const detectClientPlatform = (
    userAgent: string | null | undefined,
    appLinks: AppMarketingAppLinks
): ClientPlatformDetails => {
    if (!userAgent) {
        return {
            platform: undefined,
            appLink: undefined,
            isMobile: false
        };
    }

    const isIos = /iPad|iPhone|iPod/.test(userAgent) || /Macintosh.*Mobile/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    const isMac = /Macintosh/.test(userAgent);
    const isWindows = /Windows/.test(userAgent);

    const platformChecks: Record<AppMarketingPlatform, boolean> = {
        ios: isIos,
        android: isAndroid,
        mac: isMac,
        windows: isWindows
    };

    const platform = SUPPORTED_PLATFORMS.find((platformOs) => platformChecks[platformOs]);

    return {
        platform,
        appLink: platform ? appLinks[platform] : undefined,
        isMobile: isIos || isAndroid
    };
};
